export default "__VITE_ASSET__BtPvzmJS__"